export default {
  section_title: 'Waluta',
  label: 'Waluta',
  tooltip:
    'Waluta, w której podawane są Twoje ceny, wypłaty i raporty. Jest ustawiana dla Twojego konta partnera podczas jego tworzenia i nie można jej tu zmienić — jeśli jest nieprawidłowa, skontaktuj się z pomocą techniczną.',
  from_your_partner: 'Od Twojego partnera',
  set_for_your_account: 'Ustawiona dla Twojego konta',
};
